<template>
    <div class="col-12 nopads">
        <top-bar :current-view="views.USER_INFO_VIEW" />
        <alert :show="alertVisible" :message="message" :variant="variant" @alertShown=alertShown />
        <div class="col-12 main-container">
            <div class="col-xl-10 content-container mx-auto">
                <div class="col-12 nopads mt-6">
                    <b-container class="mb-3 pl-0 pr-0">
                        <b-col lg="12" class="no-gutters">
                            <h3>{{ user.first_name }} {{ user.last_name }}</h3>
                        </b-col>
                    </b-container>

                    <b-container class="mb-3 pl-0 pr-0">
                        <!--Name-->
                        <b-card-body class="no-gutters" v-if="user">
                            <div>
                                <span class="span-title float-left"> {{ $t('login.firstname') }}</span>
                                <b-form-input v-model="user.firstName" type="text" id="inputFirstname"
                                    :placeholder="$t('login.firstname')" />

                                <span class="span-title float-left"> {{ $t('login.lastname') }}</span>
                                <b-form-input v-model="user.lastName" type="text" id="inputLastname"
                                    :placeholder="$t('login.lastname')" />
                                <span class="span-title float-left"> {{ $t('login.phonenumber') }}</span>
                                <b-form-input v-model="user.phonenumber" type="text" id="inputPhoneNumber"
                                    :placeholder="$t('login.phonenumber')" />
                            </div>
                        </b-card-body>
                        <div class="col-sm-12 no-gutters button-container">
                            <b-button class="fair-button" variant="success" :disabled="loading"
                                @click.stop="submitUser">
                                <span>
                                    {{ $t('common.save') }}
                                </span>
                            </b-button>
                        </div>

                        <b-card-body class="no-gutters">
                            <div>
                                <div>
                                    <span class="title">{{ $t('user.change_password') }}</span>

                                    <span class="span-title float-left"> {{ $t('user.old_password') }}</span>
                                    <b-form-input v-model="oldPassword" class="mt-1" type="password" id="oldPassword"
                                        :placeholder="$t('user.old_password')" required />
                                    <span v-if="!isValidPassword(oldPassword)" class="note float-left">
                                        {{ $t('user.too_short') }}
                                    </span>
                                </div>
                                <br />

                                <div>
                                    <span class="span-title float-left"> {{ $t('user.new_password') }}</span>
                                    <b-form-input v-model="newPassword" class="mt-1"
                                        :disabled="!isValidPassword(oldPassword)" type="password" id="newPassword"
                                        :placeholder="$t('user.new_password')" required autofocus />
                                    <span v-if="!isValidPassword(newPassword)" class="note float-left">
                                        {{ $t('user.too_short') }}
                                    </span>
                                </div>
                                <br />
                                <div>
                                    <span class="span-title float-left"> {{ $t('user.confirm_password') }}</span>
                                    <b-form-input v-model="newPassword2" :disabled="!isValidPassword(newPassword)"
                                        class="mt-1" type="password" id="newPassword2"
                                        :placeholder="$t('user.confirm_password')" required />
                                    <span v-if="newPassword2 && newPassword2 !== newPassword" class="note float-left">
                                        {{ $t('user.not_identical') }}
                                    </span>
                                </div>
                            </div>
                        </b-card-body>
                        <div class="col-sm-12 no-gutters button-container">
                            <b-button class="fair-button" variant="success"
                                :disabled="loading || !newPassword2 || (newPassword2 && newPassword2 !== newPassword)"
                                @click.stop="changePassword">
                                <span>
                                    {{ $t('common.save') }}
                                </span>
                            </b-button>
                        </div>
                    </b-container>
                </div>
            </div>
            <footer-area />
        </div>
        <div v-if="loading" id="loader" class="spinner" />
    </div>
</template>

<script>
import { views } from "../mixins/ViewMixin"
import TopBar from "../components/TopBar";
import FairApi from "../modules/api";
import { userHelper } from "../mixins/UserMixin";
import { alertMixin } from "../mixins/AlertMixin"
import Alert from "../components/Alert"
import FooterArea from "@/components/FooterArea";

export default {
    name: "user-info-view",
    mixins: [views, userHelper, alertMixin],
    components: { FooterArea, TopBar, Alert },
    data() {
        return {
            views,
            user: null,
            loading: false,
            fullUserInfo: null,
            oldPassword: null,
            newPassword: null,
            newPassword2: null
        }
    },

    created() {
        this.user = this.$store.state.user
        this.fetchUserInfo()
    },

    methods: {

        fetchUserInfo: function () {
            this.loading = true
            FairApi.get(FairApi.user(), this.success, this.fail)
        },

        success: function (response) {
            this.loading = false
            this.fullUserInfo = response
        },

        fail: function () {
            this.loading = false
            this.showAlert(this.$t('common.alert_update_failed'))
        },

        updateSuccess: function() {
            this.$store.commit('mergeUser', this.user);
            this.close();
        },

        close: function () {
            this.$router.push({ name: 'main-view' })
        },

        changePassword: function () {
            this.loading = true
            FairApi.put(FairApi.userChangePsw(), { new_password: this.newPassword, old_password: this.oldPassword },
                this.changePasswordSuccess, this.changePasswordFail)
        },

        changePasswordSuccess: function () {
            this.loading = false
            this.clearPassInput()
            this.showAlert(this.$t('user.password_update'), "info")
        },

        changePasswordFail: function () {
            this.loading = false
            this.clearPassInput()
            this.showAlert(this.$t('common.alert_update_failed'))
        },

        clearPassInput: function () {
            this.oldPassword = null
            this.newPassword = null
            this.newPassword2 = null
        },

        submitUser: function () {
            let json = this.setDefaultValues(this.user)
            if (json !== undefined) {
                this.loading = true
                FairApi.put(FairApi.user(), json, this.updateSuccess, this.submitUserFail)
            }
        },

        setDefaultValues: function (userUpdate) {
            let user = JSON.parse(JSON.stringify(userUpdate))
            if (!user.firstName) {
                this.showAlert(this.$t('user.invalid_first_name'))
                return undefined
            }
            if (!user.lastName) {
                this.showAlert(this.$t('user.invalid_last_name'))
                return undefined
            }

            if (!user.phonenumber) {
                this.showAlert(this.$t('user.invalid_phonenumber'))
                return undefined
            }
            return user
        },

        submitUserFail: function () {
            this.loading = false
            this.showAlert(this.$t('common.alert_update_failed'))
        }
    }
}
</script>

<style scoped></style>